import React, { useState } from "react";
import "./styles.css";

function TextInput({
  type = "text",
  label,
  required,
  isError,
  onChange,
  value,
  name,
  Icon,
  seltectRequired,
  onBlur,
  color,
  style,
  maxLength,
  placeholder
}) {
  return (
    <div className={!isError ? `input-container` : "error-container"}>
      <input
        type={type}
        value={value}
        onChange={onChange}
        name={name}
        onBlur={onBlur}
        style={style}
        maxLength={maxLength}
        placeholder={placeholder}
      />
      <label className={value && "filled"} style={{ fontSize: "14px" }}>
        {Icon && (
          <Icon color={color} size={15} style={{ marginRight: "10px" }} />
        )}
        {label} {required && <span className="color-orange ">*</span>}
        {seltectRequired && (
          <select>
            <option></option>
          </select>
        )}
      </label>
    </div>
  );
}
export default TextInput;
